import React, { useState, useContext, useMemo } from 'react'
import ModalWindow from 'components/ModalWindow'
import { Button, Icon, Table } from 'semantic-ui-react'
import { injectIntl } from 'react-intl'
import { UserContext } from 'context'


const ApplicationDetailsModal = (props) => {
    const { application, intl } = props

    const [open, setOpen] = useState(false)
    const { currentUser } = useContext(UserContext)

    const translates = useMemo(() => ({
        notFound: intl.formatMessage({ id: 'title.recordNotFound' }),
        detail: intl.formatMessage({ id: 'btn.detail' }),
        applicationCreationDate: intl.formatMessage({ id: 'title.applicationCreationDate' }),
        applicationConfirmedDate: intl.formatMessage({ id: 'title.applicationConfirmedDate' }),
        vehicleNumber: intl.formatMessage({ id: 'title.vehicleNumber' }),
        driverOrCarrier: intl.formatMessage({ id: 'title.driverOrCarrier' }),
        counterpartyPhone: intl.formatMessage({ id: 'title.counterpartyPhone' }),
        carrierPhone: intl.formatMessage({ id: 'title.carrierPhone' }),
        applicationCanceledDate: intl.formatMessage({ id: 'title.applicationCanceledDate' }),
        applicationUserRejected: intl.formatMessage({ id: 'title.applicationUserRejected' }),
        applicationRejectionReason: intl.formatMessage({ id: 'title.applicationRejectionReason' }),
        applicationCanceledByCounterparty: intl.formatMessage({ id: 'title.applicationCanceledByCounterparty' }),
    }), [intl.locale]) // eslint-disable-line react-hooks/exhaustive-deps

    const openModal = () => {
        setOpen(true)
    }

    const generateTableRow = (title, value) => {
        if (!value) return null;

        return (
            <Table.Row key={title + value}>
                <Table.Cell className="applicationTitle"><b>{title}:</b></Table.Cell>
                <Table.Cell className="applicationValue">{value}</Table.Cell>
            </Table.Row>
        )
    }

    return (
        <ModalWindow
            closeIcon
            iconType="info"
            title={translates.detail}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => openModal()}
            trigger={
                <Button className="actionButton" icon><Icon name="info circle" /><span>{translates.detail}</span></Button>
            }
        >
            <div className="applicationDetails">
                <Table basic="very" celled striped>
                    <Table.Body>
                        {generateTableRow(translates.applicationCreationDate, application.createdDate)}
                        {application.statusId === 4 && generateTableRow(translates.applicationCanceledDate, application.updatedDate)}
                        {(application.statusId === 3 || application.statusId === 5 || application.statusId === 6) && generateTableRow(translates.applicationConfirmedDate, application.confirmedDate)}
                        {currentUser.role !== 3 && (application?.phones.length > 0 ?
                            application.phones.map(({ phone }) => generateTableRow(translates.counterpartyPhone, phone))
                            :
                            generateTableRow(translates.counterpartyPhone, translates.notFound)
                        )}
                        {application.statusId === 4 && generateTableRow(translates.applicationUserRejected, application.userRejectsName)}
                        {application.statusId === 4 && (application.rejectionReason ?
                            generateTableRow(translates.applicationRejectionReason, intl.formatMessage({ id: `rejectionReason.${application.rejectionReason}` }))
                            :
                            generateTableRow(translates.applicationRejectionReason, translates.applicationCanceledByCounterparty))
                        }
                    </Table.Body>
                </Table>
            </div>
        </ModalWindow>
    )
}

export default injectIntl(ApplicationDetailsModal)